import { FILTER_LABEL } from "../../../constants";

export const brandConfigurationConstants = {
  BRAND_CONFIGURATION_DATA: "BRAND_CONFIGURATION_DATA",
  REFRESH_BRAND_CONFIGURATION: "REFRESH_BRAND_CONFIGURATION",
};

export const brandConfigurationLabels = {
  ADD_TITLE: "Add Brand Configuration",
  SELECT_BRAND: "Select Brand",
  SELECT_BRAND_PLACEHOLDER: "Select a brand...",
  SEARCH_DEBOUNCE_MS: 1000,
  ACTION_COLUMN_SIZE: 50,
  BRAND_NAME: "BRAND NAME",
  APP_ID: "APP ID",
  SECRET: "SECRET",
  PLATFORM_TYPE: "PLATFORM TYPE",
  LAST_UPDATE: "LAST UPDATE",
  ACTION: "ACTION",
  CONFIRMATION_TITLE: "Confirmation",
  CONFIRMATION_MESSAGE:
    "Regenerating will override your existing API key. Are you sure you want to continue?",
};

export const accessTypesEnums = {
  MENUFY: { id: 1, name: "menufy", displayName: "Menufy" },
  HUNGERRUSH: { id: 2, name: "hungerRush", displayName: "HungerRush" },
  NINE_FOLD: { id: 3, name: "9fold", displayName: "9Fold" },
};

export const accessTypeFilterDropDown = [
  {
    value: "",
    name: FILTER_LABEL.ALL_PLATFORM_TYPES,
  },
  {
    value: accessTypesEnums.MENUFY.id,
    name: accessTypesEnums.MENUFY.displayName,
  },
  {
    value: accessTypesEnums.HUNGERRUSH.id,
    name: accessTypesEnums.HUNGERRUSH.displayName,
  },
  {
    value: accessTypesEnums.NINE_FOLD.id,
    name: accessTypesEnums.NINE_FOLD.displayName,
  },
];

export const AccessTypeText = {
  [accessTypesEnums.MENUFY.id]: accessTypesEnums.MENUFY.name,
  [accessTypesEnums.HUNGERRUSH.id]: accessTypesEnums.HUNGERRUSH.name,
  [accessTypesEnums.NINE_FOLD.id]: accessTypesEnums.NINE_FOLD.name,
};
